import { ref } from "vue";
import type { Ref } from "vue";

export interface ApiErrorResult {
  readonly ErrorCode?: string;
  readonly ErrorMessage?: string;
  readonly Parameters?: { [key: string]: any };
  readonly SequenceKey?: string;
}

export interface ApiError {
  readonly status: number;
  readonly result?: ApiErrorResult;
}

export interface ApiResponse<TResult> {
  readonly inProgress: Ref<boolean>;
  readonly result: Ref<TResult | undefined>;
  readonly error: Ref<ApiError | undefined>;
}

export function resolveApiPromise<TResult>(apiPromise: Promise<TResult>,
  onError?: (error: ApiError) => void,
  onSuccess?: (result: TResult) => void,
  onFinally?: () => void
): ApiResponse<TResult> {
  const result: Ref<TResult | undefined> = ref(undefined);
  const error: Ref<ApiError | undefined> = ref(undefined);
  const inProgress = ref(false);

  async function makeApiCall() {
    inProgress.value = true;
    result.value = undefined;
    error.value = undefined;

    try {
      const apiResult = await apiPromise;
      result.value = apiResult;

      if (onSuccess != null)
        onSuccess(apiResult);
    }
    catch (err) {
      const apiError: ApiError = {
        //@ts-ignore
        status: err.status,
        //@ts-ignore
        result: err.result as ApiErrorResult
      };

      error.value = apiError;

      if (onError != null)
        onError(apiError);
    }
    finally {
      inProgress.value = false;

      if (onFinally != null)
        onFinally();
    }
  }

  makeApiCall();

  return { result, error, inProgress }
}
